/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum TagType {
  Tag = "tag",
  Skill = "skill",
  Industry = "industry",
  SubIndustry = "subIndustry",
  LawSchoolRank = "lawSchoolRank",
}

export const TagTypeDisplay: Record<TagType, string> = {
  [TagType.Tag]: "Tag",
  [TagType.Skill]: "Skill",
  [TagType.Industry]: "Industry",
  [TagType.SubIndustry]: "Sub Industry",
  [TagType.LawSchoolRank]: "Law School Rank",
};
